
import { useTranslation } from 'react-i18next';
import React from 'react';

const ErrorAuthComponent = () => {
    const { t } = useTranslation();
    return (
        <div role="alert">
            <pre style={{ color: "red" }}>{t(`sessionExpired`)}</pre>
        </div>);
};
 
export default ErrorAuthComponent;